import { Component, ElementRef, EventEmitter, inject, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { UserLoginService } from 'src/app/Common/UserLoginService/userlogin.service';
import { accordionAnimation } from '../animations/animations';
import { DocMasterService } from 'src/app/Common/DocMasterService/docMaster.service';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpEventType } from '@angular/common/http';
import { DocumentMasterDTO } from 'src/app/Common/DocumentMasterService/documentmaster.interface';
import { DocumentMaster_Upload } from 'src/app/GlobalVariables';
import { DocMasterCreateRequestDTO, DocMasterDeleteRequestDTO, DocMasterDTO, DocMasterReadByDocTypeRequestDTO, DocMasterReadByMasterIdRequestDTO, DocMasterUpdateRequestDTO } from 'src/app/Common/DocMasterService/docMaster.interface';
import { GenericFormUICDTO, GenericFormUICReadByTenantIdRequestDTO } from 'src/app/Common/UICServices/FormUIC/form-uic.interface';
import { GenericFormUICService } from 'src/app/Common/UICServices/FormUIC/form-uic.service';
import { GenericListUicService } from 'src/app/Common/UICServices/ListUIC/list-uic.service';
import { GenericListUICDTO, GenericListDataReadAllPaginatedRequestDTO } from 'src/app/Common/UICServices/ListUIC/list-uic.interface';
import { UICMasterType } from 'src/app/Common/UICServices/uic.enum';
import { UicFormComponent } from '../uic-form/uic-form.component';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';


@Component({
  selector: 'app-document-upload-master',
  templateUrl: './document-upload-master.component.html',
  styleUrls: ['./document-upload-master.component.css'],
  animations: [accordionAnimation]
})
export class DocumentUploadMasterComponent implements OnInit {
  uploadedFileUrl: string | null = null;
  @Input() masterId: number = 0;
  @Input() masterType: string = '';
  @Input() editMode: boolean = false;
  @Input() invokedByParent: boolean = false;
  @Output() DocumentDetailDataEmit: EventEmitter<DocMasterDTO[]> = new EventEmitter();
  docMasterService = inject(DocMasterService);

  UICFormService = inject(GenericFormUICService);
  UICListService = inject(GenericListUicService);
  uicForm: GenericFormUICDTO[] = [];
  uicList: GenericListUICDTO[] = [];



  @ViewChild('modal') modalRef!: ElementRef<HTMLDivElement>;

  previewUrl: SafeResourceUrl | string = '';
  urlForWindow: string = '';
  fileType: 'image' | 'pdf' | 'doc' | 'office' | 'text' | 'html' | 'video' | 'audio' | 'other' | 'empty' | '' = '';
  sanitizer = inject(DomSanitizer);

  @ViewChild('uicFormRef') UicFormComponent!: UicFormComponent;

  User = inject(UserLoginService).User();

  router = inject(Router)
  currentView: string = 'card';
  activatedRoute = inject(ActivatedRoute);

  searchText: string = '';

  DocumentForm = new FormGroup({
    docId: new FormControl(0),
    docName: new FormControl('', Validators.required),
    docDesc: new FormControl(''),
    issuedDate: new FormControl(''),
    expiryDate: new FormControl(''),
    docType: new FormControl(''),
    otherDetail1: new FormControl(''),
    otherDetail2: new FormControl(''),
    otherDetail3: new FormControl(''),
    otherDetail4: new FormControl(''),
    otherDetail5: new FormControl(''),
    otherDetail6: new FormControl(''),
    isActive: new FormControl(1),
    isDeleted: new FormControl(0),
    createdBy: new FormControl(''),
    createdOn: new FormControl(new Date().toISOString().slice(0, 16)), // default datetime
    modifiedBy: new FormControl(''),
    modifiedOn: new FormControl(new Date().toISOString().slice(0, 16)),
    masterId: new FormControl(0),
    masterType: new FormControl(''),
    docURL: new FormControl(''),
    actionUser: new FormControl('')   // as per your requirement
  });

  loading: boolean = false;
  documentTypes: string[] = ['Passport', 'Driver License', 'ID Card', 'Other'];
  documentDataList: DocMasterDTO[] = [];
  documentData: any[] = []

  // Mobile camera capture state
  http             = inject(HttpClient);
  captureUploading = false;
  captureProgress: number | null = null;

  readonly DEFAULT_PAGE_SIZE = 10;

  ReadAllDTO: GenericListDataReadAllPaginatedRequestDTO = {
    whereClause: `((A.MasterId =''${this.masterId}'' AND A.masterType = ''${this.masterType}''))`,
    orderByClause: '',
    pageSize: 10,
    pageNo: 1,
    rowNum: 0,
    totalCount: 0,
    masterType: UICMasterType.DocMasterReadAllPaginated,
    tenantId: this.User.companyId,
    tenantBranchId: this.User.loggedInBranchId,
  }

  searchForm = new FormGroup({
    whereClause: new FormControl('')
  })


  ngOnInit(): void {
    this.getUICForm();
    this.getUICList();
    this.ReadAllDTO.pageNo   = 1;
    this.ReadAllDTO.pageSize = this.DEFAULT_PAGE_SIZE;
    this.GetDocumentData(this.ReadAllDTO);
  }

  setView(view: string) {
    this.currentView = view;
  }


  getUICForm() {
    let data: GenericFormUICReadByTenantIdRequestDTO = {
      masterType: UICMasterType.DocMasterForm,
      tenantId: this.User.companyId
    }

    this.UICFormService.GenericFormUIC_ReadByTenantId(data).subscribe((res) => {
      this.uicForm = res.items
    })
  }

  getUICList() {
    let data: GenericFormUICReadByTenantIdRequestDTO = {
      masterType: UICMasterType.DocMasterList,
      tenantId: this.User.companyId
    }

    this.UICListService.GenericListUIC_ReadByTenantId(data).subscribe((res) => {
      this.uicList = res.items;
    })
  }

  // ReadAllPaginated() {
  //   let data: DocMasterReadByMasterIdRequestDTO = {
  //     masterId: this.masterId,
  //     masterType: this.masterType
  //   }

  //   this.docMasterService.DocMaster_ReadByMasterId(data).subscribe((res) => {
  //     this.documentDataList = res.items;
  //   })
  // }

  handlePageSizeChange(event: { currentPage: number; pageSize: number }) {
    const { currentPage, pageSize } = event;
    this.ReadAllDTO.pageNo   = currentPage;
    this.ReadAllDTO.pageSize = pageSize;
    this.GetDocumentData(this.ReadAllDTO);
  }



  GetDocumentData(data: GenericListDataReadAllPaginatedRequestDTO) {
    this.loading = true;

    const searchText = this.searchForm.controls.whereClause.value?.trim() || '';

    data.whereClause = searchText
      ? `(A.DocName LIKE ''%${searchText}%'' AND (A.MasterId =''${this.masterId}'' AND A.masterType = ''${this.masterType}''))`
      : `((A.MasterId =''${this.masterId}'' AND A.masterType = ''${this.masterType}''))`;


    data.pageNo = data.pageNo || 1; // safe guard

    this.UICListService.GenericListData_ReadAllPaginated(data).subscribe({
      next: (res) => {
        this.documentData = res;
        this.loading = false;
      },
      error: () => (this.loading = false)
    });
  }



  loadData() {
    this.ReadAllDTO = {
      whereClause: '',
      orderByClause: '',
      pageSize: this.DEFAULT_PAGE_SIZE,
      pageNo: 1,
      rowNum: 0,
      totalCount: 0,
      masterType: UICMasterType.DocMasterReadAllPaginated,
      tenantId: this.User.companyId,
      tenantBranchId: this.User.loggedInBranchId,
    }
    this.GetDocumentData(this.ReadAllDTO)
  }

  clearSearchAndReload() {
    this.searchText = '';
    this.searchForm.controls.whereClause.setValue('');
    this.ReadAllDTO = {
      whereClause: '',
      orderByClause: '',
      pageSize: this.DEFAULT_PAGE_SIZE,
      pageNo: 1,
      rowNum: 0,
      totalCount: 0,
      masterType: UICMasterType.DocMasterReadAllPaginated,
      tenantId: this.User.companyId,
      tenantBranchId: this.User.loggedInBranchId,
    }
    this.GetDocumentData(this.ReadAllDTO);
  }





  submitUICForm() {
    this.UicFormComponent.gFormGroup.markAllAsTouched();

    if (this.UicFormComponent.gFormGroup.valid) {
      const formValues = this.UicFormComponent.gFormGroup.value;

      let data: DocMasterUpdateRequestDTO = {
        docId: formValues.docId ?? 0,
        tenantId: this.User.companyId,
        tenantBranchId: this.User.loggedInBranchId,
        masterId: formValues.masterId ?? 0,
        masterType: formValues.masterType ?? '',
        docType: formValues.docType ?? '',
        docName: formValues.docName ?? '',
        docDesc: formValues.docDesc ?? '',
        docURL: formValues.docURL ?? '',
        issuedDate: formValues.issuedDate ? new Date(formValues.issuedDate) : undefined,
        expiryDate: formValues.expiryDate ? new Date(formValues.expiryDate) : undefined,
        otherDetail1: formValues.otherDetail1 ?? '',
        otherDetail2: formValues.otherDetail2 ?? '',
        otherDetail3: formValues.otherDetail3 ?? '',
        otherDetail4: formValues.otherDetail4 ?? '',
        otherDetail5: formValues.otherDetail5 ?? '',
        otherDetail6: formValues.otherDetail6 ?? '',
        isActive: 1,
        actionUser: this.User.userId.toString()
      }


      if (this.invokedByParent) {
        // this.documentDataList = [...(this.documentDataList || []), data as DocMasterDTO];
        this.documentDataList.push(data as DocMasterDTO);

        this.DocumentDetailDataEmit.emit(this.documentDataList);
        this.UicFormComponent.gFormGroup.reset();
      } else {
        this.submitForm(data);
      }

    }
  }




  addDocument() {
    this.editMode = true;
    this.DocumentForm.reset({
      actionUser: this.User.userId.toString(),
      masterId: this.masterId,
      masterType: this.masterType,
      isActive: 1,

    });
  }
  submitForm(data: DocMasterUpdateRequestDTO) {

    let payload: DocMasterUpdateRequestDTO = {
      docId: data.docId ?? 0,
      isActive: 1,
        tenantId: this.User.companyId,
        tenantBranchId: this.User.loggedInBranchId,
      masterId: this.masterId,
      masterType: this.masterType,
      docName: data.docName ?? '',
      docDesc: data.docDesc ?? '',
      docType: data.docType ?? '',
      issuedDate: data.issuedDate ? new Date(data.issuedDate) : undefined,
      expiryDate: data.expiryDate ? new Date(data.expiryDate) : undefined,
      docURL: data.docURL ?? '',
      otherDetail1: data.otherDetail1 ?? '',
      otherDetail2: data.otherDetail2 ?? '',
      otherDetail3: data.otherDetail3 ?? '',
      otherDetail4: data.otherDetail4 ?? '',
      otherDetail5: data.otherDetail5 ?? '',
      otherDetail6: data.otherDetail6 ?? '',
      actionUser: this.User.userId.toString()
    }

    if (payload.docId && payload.docId > 0) {
      this.docMasterService.DocMaster_Update(payload).subscribe(res => {
        this.editMode = false;
        this.GetDocumentData(this.ReadAllDTO);
      })
    } else {
      this.docMasterService.DocMaster_Create(payload).subscribe(res => {
        this.editMode = false;
        this.GetDocumentData(this.ReadAllDTO);
      })
    }
  }



  handleActionClick(event: { actionName: string; rowData: DocMasterDTO }) {
    const { actionName, rowData } = event;
    if (actionName === 'Delete') {
      let data: DocMasterDeleteRequestDTO = {
        docId: rowData.docId,
        tenantId: rowData.tenantId ?? this.User.companyId,
        tenantBranchId: rowData.tenantBranchId ?? this.User.loggedInBranchId,
        actionUser: this.User.userId.toString()
      }

      this.docMasterService.DocMaster_Delete(data).subscribe((res) => {
        this.GetDocumentData(this.ReadAllDTO);
      })
    } else if (actionName === 'View') {
      const docUrl: string = (rowData as any).DocURL || rowData.docURL || '';
      this.previewUrl = docUrl;
      this.urlForWindow = docUrl;

      // detect type
      if (!docUrl) {
        this.fileType = 'empty';
      } else if (docUrl.match(/\.(jpeg|jpg|png|gif|webp|svg|bmp|ico)$/i)) {
        this.fileType = 'image';
      } else if (docUrl.match(/\.pdf$/i)) {
        this.fileType = 'pdf';
        this.previewUrl = this.sanitizer.bypassSecurityTrustResourceUrl(docUrl);
      } else if (docUrl.match(/\.(doc|docx)$/i)) {
        this.fileType = 'doc';
        const gviewUrl = 'https://docs.google.com/gview?url=' + encodeURIComponent(docUrl) + '&embedded=true';
        this.previewUrl = this.sanitizer.bypassSecurityTrustResourceUrl(gviewUrl);
      } else if (docUrl.match(/\.(xls|xlsx|ppt|pptx)$/i)) {
        this.fileType = 'office';
        const gviewUrl = 'https://docs.google.com/gview?url=' + encodeURIComponent(docUrl) + '&embedded=true';
        this.previewUrl = this.sanitizer.bypassSecurityTrustResourceUrl(gviewUrl);
      } else if (docUrl.match(/\.(txt|csv|json|xml|md)$/i)) {
        this.fileType = 'text';
        fetch(docUrl).then(r => r.text()).then(t => this.textContent = t);
      } else if (docUrl.match(/\.(html|htm)$/i)) {
        this.fileType = 'html';
        this.previewUrl = this.sanitizer.bypassSecurityTrustResourceUrl(docUrl);
      } else if (docUrl.match(/\.(mp4|webm|avi|mov|mkv)$/i)) {
        this.fileType = 'video';
        const vext = docUrl.split('?')[0].split('.').pop()?.toLowerCase() || '';
        this.videoError = !this.checkVideoSupport(vext);
        this.previewUrl = this.sanitizer.bypassSecurityTrustResourceUrl(docUrl);
      } else if (docUrl.match(/\.(mp3|wav|aac|flac|ogg)$/i)) {
        this.fileType = 'audio';
        this.previewUrl = this.sanitizer.bypassSecurityTrustResourceUrl(docUrl);
      } else {
        this.fileType = 'other';
      }

      this.modalRef.nativeElement.style.display = 'block';

    }
  }

  openInNewWindow() {
    if (this.urlForWindow) {
      window.open(this.urlForWindow as string, '_blank');
    }
  }


  closePreview() {
    this.modalRef.nativeElement.style.display = 'none';
    this.previewUrl = '';
    this.fileType = '';
  }


  /**
   * Mobile camera capture — triggered by the hidden <input capture> elements.
   * Uploads the captured file then auto-saves a DocMaster record so the
   * attachment appears immediately without the user filling in a form.
   */
  onCaptureSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    const file  = input.files?.[0];
    if (!file) return;
    input.value = ''; // reset so same file can be captured again if needed

    this.captureUploading = true;
    this.captureProgress  = 0;

    const formData = new FormData();
    formData.append('File',      file, file.name);
    formData.append('CompanyId', this.User.companyId.toString());
    formData.append('BranchId',  this.User.loggedInBranchId.toString());
    formData.append('SoftwareId', environment.SoftwareId);

    this.http.post<DocumentMasterDTO>(DocumentMaster_Upload, formData, {
      reportProgress: true,
      observe: 'events'
    }).subscribe({
      next: (httpEvent) => {
        if (httpEvent.type === HttpEventType.UploadProgress) {
          this.captureProgress = Math.round(
            (httpEvent.loaded / (httpEvent.total || 1)) * 100
          );
        } else if (httpEvent.type === HttpEventType.Response) {
          this.captureUploading = false;
          this.captureProgress  = null;

          const uploadedUrl = httpEvent.body?.url;
          if (!uploadedUrl) return;

          const isVideo = file.type.startsWith('video/');

          const payload: DocMasterUpdateRequestDTO = {
            docId:          0,
            tenantId:       this.User.companyId,
            tenantBranchId: this.User.loggedInBranchId,
            masterId:       this.masterId,
            masterType:     this.masterType,
            docName:        file.name,
            docDesc:        '',
            docType:        isVideo ? 'Video' : 'Photo',
            docURL:         uploadedUrl,
            issuedDate:     undefined,
            expiryDate:     undefined,
            otherDetail1: '', otherDetail2: '', otherDetail3: '',
            otherDetail4: '', otherDetail5: '', otherDetail6: '',
            isActive:       1,
            actionUser:     this.User.userId.toString()
          };

          this.docMasterService.DocMaster_Create(payload).subscribe(() => {
            this.GetDocumentData(this.ReadAllDTO);
          });
        }
      },
      error: () => {
        this.captureUploading = false;
        this.captureProgress  = null;
      }
    });
  }

  //   ngOnChanges(changes: SimpleChanges): void {
  //   if ((changes['masterId'] && this.masterId) || (changes['masterType'] && this.masterType)) {
  //     this.loadDocumentDetails();
  //   }
  // }
  // loadDocumentDetails() {
  //   let data: DocMasterReadByDocTypeRequestDTO = {
  //     docType: ''
  //   }
  //   // this.documentService.DocMaster_ReadAll().subscribe(res => {
  //   //   this.documentList = res.items
  //   // })
  //   //     this.documentService.DocMaster_ReadByDocType(data).subscribe(res => {
  //   //   this.documentList = res.items
  //   // })
  // }



  files = [
  { name: 'Invoice.pdf', url: 'assets/files/invoice.pdf' },
  { name: 'Photo.jpg', url: 'assets/files/photo.jpg' },
  { name: 'Report.docx', url: 'assets/files/report.docx' },
  { name: 'Excel.xlsx', url: 'assets/files/data.xlsx' },
  { name: 'Notes.txt', url: 'assets/files/note.txt' }
];

selectedFile: any = null;
selectedFileUrl: string = '';
officeUrl = '';
textContent = '';

isPdf = false;
isImage = false;
isOffice = false;
isText = false;
isHtml = false;
isVideo = false;
isAudio = false;
isUnknown = false;
videoError = false;
htmlContent = '';

htmlSafeUrl!: SafeResourceUrl;
preview(file: any) {
  this.resetFlags();

  if (!file) return;

  const url =
    file.DocURL || file.docURL ||
    file.filePath ||
    file.documentPath ||
    file.fullPath;

  if (!url) return;

  this.selectedFile = file;
  this.selectedFileUrl = url;

  const cleanedUrl = url.split('?')[0];
  const ext = cleanedUrl.substring(cleanedUrl.lastIndexOf('.') + 1).toLowerCase();

  switch (ext) {
    case 'pdf':
      this.isPdf = true;
      break;

    case 'jpg':
    case 'jpeg':
    case 'png':
    case 'gif':
    case 'webp':
    case 'svg':
    case 'bmp':
    case 'ico':
      this.isImage = true;
      break;

    case 'doc':
    case 'docx':
    case 'xls':
    case 'xlsx':
    case 'ppt':
    case 'pptx':
      this.isOffice = true;
      this.officeUrl =
        `https://docs.google.com/gview?url=${encodeURIComponent(url)}&embedded=true`;
      break;

    case 'txt':
    case 'csv':
    case 'json':
    case 'xml':
    case 'md':
      this.isText = true;
      fetch(url).then(r => r.text()).then(t => this.textContent = t);
      break;

    case 'html':
    case 'htm':
      this.isHtml = true;
      this.htmlSafeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
      break;

    case 'mp4':
    case 'webm':
    case 'avi':
    case 'mov':
    case 'mkv':
      this.isVideo = true;
      this.videoError = !this.checkVideoSupport(ext);
      break;

    case 'mp3':
    case 'wav':
    case 'aac':
    case 'flac':
    case 'ogg':
      this.isAudio = true;
      break;

    default:
      this.isUnknown = true;
      break;
  }
}

// ── File-type helper methods ────────────────────────────────────

  /** Bootstrap-icon class for a given document row */
  getFileTypeIcon(file: any): string {
    const url = (file?.DocURL || file?.docURL || '').toLowerCase();
    if (/\.(jpg|jpeg|png|gif|webp|svg|bmp|ico)$/.test(url)) return 'bi bi-file-earmark-image-fill';
    if (/\.pdf$/.test(url))                                  return 'bi bi-file-earmark-pdf-fill';
    if (/\.(doc|docx)$/.test(url))                          return 'bi bi-file-earmark-word-fill';
    if (/\.(xls|xlsx)$/.test(url))                          return 'bi bi-file-earmark-excel-fill';
    if (/\.(ppt|pptx)$/.test(url))                          return 'bi bi-file-earmark-ppt-fill';
    if (/\.(mp4|webm|avi|mov|mkv)$/.test(url))              return 'bi bi-file-earmark-play-fill';
    if (/\.(mp3|wav|aac|flac|ogg)$/.test(url))              return 'bi bi-file-earmark-music-fill';
    if (/\.(txt|csv|json|xml|md)$/.test(url))               return 'bi bi-file-earmark-text-fill';
    if (/\.(zip|rar|7z|gz|tar)$/.test(url))                 return 'bi bi-file-earmark-zip-fill';
    return 'bi bi-file-earmark-fill';
  }

  /** CSS class that sets the icon-area background/colour */
  getFileTypeClass(file: any): string {
    const url = (file?.DocURL || file?.docURL || '').toLowerCase();
    if (/\.(jpg|jpeg|png|gif|webp|svg|bmp|ico)$/.test(url)) return 'doc-icon--image';
    if (/\.pdf$/.test(url))                                  return 'doc-icon--pdf';
    if (/\.(doc|docx)$/.test(url))                          return 'doc-icon--word';
    if (/\.(xls|xlsx)$/.test(url))                          return 'doc-icon--excel';
    if (/\.(ppt|pptx)$/.test(url))                          return 'doc-icon--ppt';
    if (/\.(mp4|webm|avi|mov|mkv)$/.test(url))              return 'doc-icon--video';
    if (/\.(mp3|wav|aac|flac|ogg)$/.test(url))              return 'doc-icon--audio';
    if (/\.(zip|rar|7z|gz|tar)$/.test(url))                 return 'doc-icon--zip';
    return 'doc-icon--other';
  }

  /** Resolved display name for a document row */
  getFileName(file: any): string {
    return file?.DocName || file?.docName || 'Unnamed File';
  }

  /** Uppercase extension extracted from the URL */
  getFileExtension(file: any): string {
    const url = (file?.DocURL || file?.docURL || '').split('?')[0];
    const ext = url.split('.').pop() || '';
    return ext.toUpperCase().slice(0, 6) || 'FILE';
  }

  /** Compact date string: "12 May 2025" */
  formatDocDate(d: string): string {
    if (!d) return '';
    try {
      return new Date(d).toLocaleDateString('en-GB', {
        day: '2-digit', month: 'short', year: 'numeric'
      });
    } catch { return d; }
  }

  private checkVideoSupport(ext: string): boolean {
  const mimeTypes: { [key: string]: string } = {
    'mp4': 'video/mp4',
    'webm': 'video/webm',
    'avi': 'video/x-msvideo',
    'mov': 'video/quicktime',
    'mkv': 'video/x-matroska'
  };
  const mime = mimeTypes[ext];
  if (!mime) return false;
  const probe = document.createElement('video');
  return probe.canPlayType(mime) !== '';
}

resetFlags() {
  this.isPdf = this.isImage = this.isOffice = this.isText = this.isHtml = this.isVideo = this.isAudio = this.isUnknown = this.videoError = false;
}

}
